'use client';

import { useEffect } from 'react';
import { usePlaysoutAPI } from '../hooks/usePlaysoutAPI';

export default function PlaysoutAuthBootstrap() {
  const { isLoggedIn, isLoggingIn, error } = usePlaysoutAPI();

  useEffect(() => {
    if (isLoggingIn) {
      console.log('[PlaysoutAuthBootstrap] Playsout login in progress');
    }
  }, [isLoggingIn]);

  useEffect(() => {
    if (error) {
      console.warn('[PlaysoutAuthBootstrap] Playsout login error:', error);
    }
  }, [error]);

  useEffect(() => {
    if (isLoggedIn) {
      console.log('[PlaysoutAuthBootstrap] Playsout auth ready');
    }
  }, [isLoggedIn]);

  return null;
}
